import axj_web_state from './axj-web/state'
import common_state from './common/state'
import axj_help_state from './axj_help/state'
export default {
  ...axj_web_state,
  ...common_state,
  ...axj_help_state
}



// WEBPACK FOOTER //
// ./src/store/state.js